import React from 'react'
import type { WithStyles, Theme } from '@material-ui/core'
import { withStyles, createStyles } from '@material-ui/core'

import Chip from '@material-ui/core/Chip'

import { Typography } from '@paintscout/ui'

export const styles = (theme: Theme) => {
  return createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: `0 ${theme.spacing(0.5)}px`,
      [theme.breakpoints.down('sm')]: {
        margin: 0
      }
    },
    label: {
      marginTop: theme.spacing(0.5),
      ...theme.typography.overline,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(10)
      }
    },
    sublabel: {
      ...theme.typography.overline,
      color: theme.paintscout.palette.brand.Neutral.P70,
      fontWeight: 'normal'
    },
    chip: {
      textAlign: 'center',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        maxHeight: 20
      }
    },
    chipLabel: {
      ...theme.typography.overline,
      paddingLeft: 16,
      paddingRight: 16,
      minWidth: 35,
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
        display: 'flex',
        paddingLeft: 8,
        paddingRight: 8,
        minWidth: 0,
        '& > span': {
          fontSize: theme.typography.pxToRem(8)
        }
      }
    }
  })
}

export interface CalculationElementProps extends WithStyles<typeof styles> {
  value?: number | string
  label?: string
  sublabel?: string
  color?: 'primary' | 'secondary' | 'default'
  format?: string
  showUnits?: boolean
}

function CalculationElement({
  value,
  label,
  sublabel,
  classes,
  color = 'primary',
  format,
  showUnits
}: CalculationElementProps) {
  let sanitizedValue = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(sanitizedValue)) {
    sanitizedValue = 0
  }

  return (
    <div className={classes.root}>
      <Chip
        classes={{ root: classes.chip, label: classes.chipLabel }}
        color={color}
        size="small"
        label={
          <Typography
            variant={'overline'}
            format={format}
            showUnits={showUnits}
            showZeros={true}
            value={sanitizedValue}
          />
        }
      />
      <Typography
        variant={'overline'}
        classes={{ root: classes.label }}
        color={color !== 'default' ? color : 'inherit'}
      >
        {label ? label : ' '}
      </Typography>
      <Typography variant="caption" color={color !== 'default' ? color : 'inherit'}>
        {sublabel ? `(${sublabel})` : ''}
      </Typography>
    </div>
  )
}

export default withStyles(styles)(CalculationElement)
